import { axiosInstance } from './axiosInstance';
import { stringify } from 'services/queryString';

export const getCustomFields = (type, queryParams) =>
    axiosInstance
        .get(`customfieldtemplate/rs-read/${type}?${queryParams ? stringify(queryParams) : ''}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const getCustomFieldsCancellable = cancelToken => (type, queryParams) => {
    return axiosInstance
        .get(`customfieldtemplate/rs-read/${type}?${queryParams ? stringify(queryParams) : ''}`, { cancelToken })
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });
};

export const createCustomField = (customField, category) => {
    return axiosInstance
        .post(`customFieldTemplate/create/${category}`, customField)
        .then(response => response)
        .catch(error => {
            throw error.response;
        });
};

export const deleteCustomField = id =>
    axiosInstance
        .delete(`customFieldTemplate/${id}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const deleteCustomFieldsOnboarding = type =>
    axiosInstance
        .delete(`customFieldTemplate/onboarding/delete/${type}`)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const updateCustomFields = (customFields, category, includeDeleted = false, isOnboarding = false) =>
    axiosInstance
        .post(
            `customFieldTemplate/save/${category}`,
            { customFields, includeDeleted },
            {
                headers: {
                    'hubplanner-onboarding': isOnboarding,
                },
            }
        )
        .then(response => {
            return response.data;
        })
        .catch(error => {
            throw error.response;
        });
